import { render, staticRenderFns } from "./postIndex.vue?vue&type=template&id=fed90730&scoped=true&"
import script from "./postIndex.vue?vue&type=script&lang=js&"
export * from "./postIndex.vue?vue&type=script&lang=js&"
import style0 from "./postIndex.vue?vue&type=style&index=0&id=fed90730&prod&lang=scss&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed90730",
  null
  
)

export default component.exports